





import { defineComponent } from '@vue/composition-api';
import { OlbButton, OlbIcon } from '@olbbank/vue-components';

export default defineComponent({
	components: {
		OlbButton,
		OlbIcon,
	},
	props: {
		etracker: String,
	},
	setup(props, { root }) {
		const onClick = (e: Event) => {
			e.preventDefault();
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
			root.$emit('toggle-search');
		};
		return {
			onClick,
		};
	},
});
